import React, { Fragment } from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';

import orderStyle from '../../assets/jss/coscef/views/orderStyle';

const useStyles = makeStyles(orderStyle);

const Order = (props) => {
  const classes = useStyles();
  const fields = [
    {
      campo: 'Fecha',
      valor: 'createdAt',
    },
    {
      campo: 'Título',
      valor: 'titulo',
    },
    {
      campo: 'Autor',
      valor: 'autor',
    },
  ];
  const order = [
    {
      orden: 'Ascendente',
      valor: 'ASC',
    },
    {
      orden: 'Descendente',
      valor: 'DESC',
    },
  ];

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={5} md={5} lg={4}>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor='simple-select' className={classes.selectLabel}>
              Ordenado por
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu,
              }}
              classes={{
                select: classes.select,
              }}
              value={props.fieldBy}
              onChange={props.fieldByChange}
              inputProps={{
                name: 'field',
                id: 'simple-select',
              }}
            >
              {fields.map(({ campo, valor }) => (
                <MenuItem
                  key={campo}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={valor}
                >
                  {campo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={5} md={5} lg={4}>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor='simple-select' className={classes.selectLabel}>
              De forma
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu,
              }}
              classes={{
                select: classes.select,
              }}
              value={props.orderBy}
              onChange={props.orderByChange}
              inputProps={{
                name: 'order',
                id: 'simple-select',
              }}
            >
              {order.map(({ orden, valor }) => (
                <MenuItem
                  key={orden}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={valor}
                >
                  {orden}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

export default Order;
